/*
 * @Author: edvardchen
 * @Date:   2017-03-21 11:25:23
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2017-03-21 16:38:19
 */

import _ from 'lodash';

import scriptjs from 'scriptjs';

import querystring from 'query-string';

import { parseJSON, checkStatus } from '../fetchers/helper';

import { isWeChat } from './UA';
import isomorphicConfig from './isomorphicConfig';

const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

// 大于 100M 视为 4g
// 大于 1M 视为 3g
const DOWNLINKMAX_OF_4G = 100;
const DOWNLINKMAX_OF_3G = 1;

const fromBrowser = () => {
  const { type, downlinkMax } = connection;
  switch (type) {
    case 'wifi':
      return type;
    case 'cellular':
      if (downlinkMax >= DOWNLINKMAX_OF_4G) {
        return '4g';
      }
      if (downlinkMax > DOWNLINKMAX_OF_3G) {
        return '3g';
      }
      return '2g';
    default:
      return type;
  }
};

const appId = _.get(isomorphicConfig, 'share.appId'); // 业务自己的公众帐号的appid

const getWXToken = () => {
  const params = {
    url: window.location.href, // 必选字段
    p: 'initjssdk', // 必选固定字段
    appId,
  };
  return window
    .fetch(`//sc.qq.com/fx/getToken?${querystring.stringify(params)}`)
    .then(checkStatus)
    .then(parseJSON);
};

export const initWX = () =>
  new Promise((resolve, reject) => {
    getWXToken()
      .then((noncestr, signature, timestamp) => {
        scriptjs(isomorphicConfig.wxjs, () => {
          const { wx } = window;
          wx.config({
            appId,
            signature,
            timestamp,
            nonceStr: noncestr,
            jsApiList: ['getNetworkType', 'onMenuShareTimeline', 'onMenuShareAppMessage'],
          });
          wx.getNetworkType({
            success: ({ networkType }) => {
              resolve(networkType);
            },
          });
        });
      })
      .catch(reject);
  });

const getConnectionType = () => {
  if (connection) {
    return Promise.resolve(fromBrowser());
  }
  const { userAgent } = navigator;
  if (isWeChat(userAgent)) {
    return initWX();
  }
  return Promise.resolve();
};

export default getConnectionType;
